/* eslint-disable @typescript-eslint/no-redeclare */
export const EditorType = {
  Select: 'select',
  MultiSelect: 'multi-select',
  Boolean: 'boolean',
  Text: 'text',
  Date: 'date',
  Status: 'status',
  EntitySearch: 'entity-search',
} as const;

export type EditorType = (typeof EditorType)[keyof typeof EditorType];

export const ValueType = {
  String: 'string',
  Number: 'number',
  Boolean: 'boolean',
  Date: 'date',
  IdRef: 'id-ref',
  IdRefArray: 'id-ref-array',
} as const;

export type ValueType = (typeof ValueType)[keyof typeof ValueType];

export const WriteStrategy = {
  SimpleUpdate: 'simple-update',
  AssociationReplace: 'association-replace',
  AssociationEnsureThenUpdate: 'association-ensure-then-update',
  AssociationAdd: 'association-add',
  LabelMutation: 'label-mutation',
  SoftDelete: 'soft-delete',
} as const;

export type WriteStrategy = (typeof WriteStrategy)[keyof typeof WriteStrategy];

export const Concurrency = {
  Parallel: 'parallel',
  Serial: 'serial',
} as const;

export type Concurrency = (typeof Concurrency)[keyof typeof Concurrency];

export const ConflictDetection = {
  ValueEquality: 'value-equality',
  None: 'none',
} as const;

export type ConflictDetection = (typeof ConflictDetection)[keyof typeof ConflictDetection];

export const SubmitMode = {
  BulkUpdate: 'bulk-update',
  AssociateClientsWithAddress: 'associate-clients-with-address',
} as const;

export type SubmitMode = (typeof SubmitMode)[keyof typeof SubmitMode];

export const ConstraintKey = {
  UrgencyAllowlist: 'urgency-allowlist',
  AssigneeGroupAllowlist: 'assignee-group-allowlist',
  ServiceLevelBrand: 'service-level-brand',
  AddressUniqueness: 'address-uniqueness',
  VisibleLabelsForEntity: 'visible-labels-for-entity',
  ActiveClientInPartner: 'active-client-in-partner',
} as const;

export type ConstraintKey = (typeof ConstraintKey)[keyof typeof ConstraintKey];

export const ImplicitFieldStrategy = {
  ClearOnUpdate: 'clear-on-update',
  SetFromMetadata: 'set-from-metadata',
  SetTimestamp: 'set-timestamp',
} as const;

export type ImplicitFieldStrategy =
  (typeof ImplicitFieldStrategy)[keyof typeof ImplicitFieldStrategy];
